import styled, { css } from 'styled-components';
import Text from '../Text';
import Sort from '../Sort/Sort.jsx';

const Th = styled.th`
  border: none;
  white-space: nowrap;
  padding: ${props => props.padding};
  padding-bottom: 16px;
`;

const Tr = styled.tr`
  &:hover {
    background: transparent !important;
  }
`;

const ThContentWrapper = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 8px;
  justify-content: ${props =>
    props.alignment === 'right' ? 'flex-end' : 'flex-start'};
  ${props =>
    props.sortable &&
    css`
      flex-direction: ${props.sortLocation === 'right' ? 'row-reverse' : 'row'};
      cursor: pointer;
    `};
`;

const Header = ({ columns, sortingStatus, changeSort }) => {
  return (
    <thead>
      <Tr>
        {columns.map(column => (
          <Th
            key={column.columnName}
            padding={column.padding}
            data-tip={column.tooltipText}
            data-for={column.tooltipStyle}
            data-offset={column.tooltipOffset}
          >
            <ThContentWrapper
              onClick={
                column.sortable
                  ? () => changeSort(column.columnName)
                  : undefined
              }
              alignment={column.alignment}
              sortLocation={column.sortLocation}
              sortable={column.sortable}
            >
              {column.sortable && (
                <Sort
                  sortingStatus={sortingStatus}
                  columnName={column.columnName}
                />
              )}
              <Text variant="subtitle2" color="black.100">
                {column.title}
              </Text>
            </ThContentWrapper>
          </Th>
        ))}
      </Tr>
    </thead>
  );
};

export default Header;
